/** @jsx jsx */
import { jsx, css, Global } from '@emotion/react'
import { Fragment } from 'react'

const tooltip = css`
  font-size: 0.875rem;
  background-color: #555;
`

export default function GlobalStyles() {
  return (
    <Fragment>
      <Global
        styles={css`
          html {
            /* mobile viewport bug fix */
            height: -webkit-fill-available;
          }

          body {
            @font-face {
              font-family: 'Inter';
              font-style: normal;
              font-weight: 400;
              src: local(''), url('/public/fonts/Inter/Inter-Regular.ttf') format('ttf');
            }
            font-family: Inter, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            height: inherit;
            min-height: 100vh;
            /* mobile viewport bug fix */
            min-height: -webkit-fill-available;
            margin: 0;
          }

          #root {
            min-height: inherit;
            height: inherit;
          }

          code {
            font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
          }

          .highlight {
            background-color: yellow;
          }

          .MuiButton-root.MuiButton-root.MuiButton-root {
            text-transform: none;
          }

          .MuiTooltip-popper .MuiTooltip-tooltip {
            ${tooltip};
          }
          .Settings_Vendors-inviteStateTooltip {
            ${tooltip};
            margin-left: 0.25rem;
          }
          .Settings_Vendors-actionBarTooltip {
            ${tooltip};
          }
          .Settings_ContactGroups-actionBarTooltip {
            ${tooltip};
          }
          .Settings_Organizations-actionBarTooltip {
            ${tooltip};
          }
          .WorkflowItems-responseCountTooltip {
            ${tooltip};
            margin-top: 0.125rem;
          }
          .Workspace-DashboardNavigationDrawer-drawerItem {
            ${tooltip};
            margin-left: 0.125rem !important;
          }
        `}
      />
    </Fragment>
  )
}
